module.exports = __webpack_public_path__ + "img/Banner-08.81076c4d.png";